module.exports = __webpack_public_path__ + "static/media/icon_filter_active.794957f5.svg";